import { useState } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');
  const formUrl = 'https://readdy.ai/api/form/d9rcsr6e3oq4jqumtvmg';

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypotInput = form.querySelector<HTMLInputElement>('input[name="company_alt"]');
    if (honeypotInput && honeypotInput.value.trim() !== '') {
      setStatus('success');
      setEmail('');
      return;
    }

    if (!email.trim()) return;

    setStatus('loading');
    setErrorMsg('');

    try {
      const formData = new FormData(form);
      const response = await fetch(formUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });

      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed && parsed.code === 'OK') {
        setStatus('success');
        setEmail('');
      } else {
        const msg = parsed?.meta?.message || parsed?.meta?.detail || parsed?.message || responseText || '订阅失败';
        if (msg.includes('spam') || msg.includes('form data is spam')) {
          setErrorMsg('订阅失败，请稍后重试。');
        } else {
          setErrorMsg(msg);
        }
        setStatus('error');
      }
    } catch {
      setErrorMsg('网络错误，请检查您的网络连接后重试。');
      setStatus('error');
    }
  };

  return (
    <section className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-3xl mx-auto text-center">
        <div className="bg-background-100 rounded-lg p-8 md:p-12">
          <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-500 mb-5">
            <i className="ri-mail-send-line text-2xl"></i>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            订阅精品内容
          </h2>
          <p className="text-foreground-600 mb-8 max-w-md mx-auto leading-relaxed">
            每周精选优质内容直接送达您的邮箱，不错过任何一篇值得阅读的好文章。免费订阅，随时退订。
          </p>

          <form
            onSubmit={handleSubmit}
            className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
            data-readdy-form=""
          >
            <input
              type="text"
              name="company_alt"
              tabIndex={-1}
              autoComplete="off"
              readOnly
              aria-hidden="true"
              className="honeypot-field"
            />
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="输入您的邮箱地址"
              required
              className="flex-1 px-4 py-3 text-sm bg-background-50 border border-background-300 rounded-md outline-none focus:border-primary-400 transition-colors duration-200"
            />
            <button
              type="submit"
              disabled={status === 'loading'}
              className="px-6 py-3 bg-primary-500 text-white text-sm font-medium rounded-md hover:bg-primary-600 transition-colors duration-200 disabled:opacity-60 whitespace-nowrap cursor-pointer"
            >
              {status === 'loading' ? '订阅中...' : '立即订阅'}
            </button>
          </form>

          {status === 'success' && (
            <p className="mt-4 text-sm text-secondary-600 font-medium">
              感谢订阅！我们已向您的邮箱发送了确认邮件。
            </p>
          )}
          {status === 'error' && errorMsg && (
            <p className="mt-4 text-sm text-accent-600 font-medium">
              {errorMsg}
            </p>
          )}
          <p className="mt-3 text-xs text-foreground-400">
            我们尊重您的隐私，不会向第三方分享您的邮箱信息。
          </p>
        </div>
      </div>
    </section>
  );
}